import { connect } from 'react-redux'
import * as pages from 'constants/pages'
import { selectAccountPreferenceDebugFrontend } from 'selectors/app/selectAccountPreferences'
import {
  selectCurrentUser,
  selectCurrentUserCanAccessAdmin,
} from 'ducks/currentUser/selectors'
import View from './view'

const select = state => ({
  currentUser: selectCurrentUser(state),
  canAccessAdmin: selectCurrentUserCanAccessAdmin(state),
  debugFrontend: selectAccountPreferenceDebugFrontend(state),
})

const perform = dispatch => ({
  handleLogout: () => dispatch({ type: pages.LOGOUT_PAGE }),
})

export default connect(select, perform)(View)
